module.exports = __webpack_public_path__ + "static/media/happywoman.d0032da8.jpg";